// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lb-0";
export var fileList = "_lb-2";
export var removeFileButton = "_lb-1";